import { useQuery } from '@tanstack/react-query';
import { listClienteMedia } from '@/services/mensagens.service';

/** Media (pronta) partilhada por um cliente — aba "Mídia" da galeria do perfil. */
export function useClienteMedia(clienteId: string | undefined) {
  return useQuery({
    queryKey: ['cliente-media', clienteId],
    queryFn: () => listClienteMedia(clienteId!),
    enabled: !!clienteId,
    staleTime: 60_000,
  });
}
